/* eslint-disable no-undef */
import axios from 'axios'
import { CreateRegisterActionProps, DispatchCreateRegisterAction } from '../../types/redux/createRegister'
import { DispatchListRegisterAction, ListRegisterActionProps } from '../../types/redux/listRegister'
import * as types from '../constantes/user'

export const CreateRegisterAction: CreateRegisterActionProps =
  (NomeEmpreendedor, CpfEmpreendedor, EmailEmpreendedor, CelularEmpreendedor, CnpjEmpresa) =>
  async (dispatch: DispatchCreateRegisterAction) => {
    dispatch({
      type: types.CREATE_REGISTER_REQUEST,
      payload: {
        NomeEmpreendedor,
        CpfEmpreendedor,
        EmailEmpreendedor,
        CelularEmpreendedor,
        CnpjEmpresa
      }
    })

    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/records/create`, {
        NomeEmpreendedor,
        CpfEmpreendedor,
        EmailEmpreendedor,
        CelularEmpreendedor,
        CnpjEmpresa
      })
      dispatch({
        type: types.CREATE_REGISTER_SUCCESS,
        payload: data.message && data.message
      })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch({
          type: types.CREATE_REGISTER_ERROR,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
      }
    }
  }

export const ListRegisterAction: ListRegisterActionProps = Key => async (dispatch: DispatchListRegisterAction) => {
  dispatch({
    type: types.LIST_REGISTER_REQUEST,
    payload: {
      Key
    }
  })

  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/records/list`, {
      Key
    })
    dispatch({
      type: types.LIST_REGISTER_SUCCESS,
      payload: data
    })
  } catch (error) {
    if (axios.isAxiosError(error)) {
      dispatch({
        type: types.LIST_REGISTER_ERROR,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message
      })
    }
  }
}
